import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { ContactPhoneOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceVendorContactEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);

  const handleChange = (value: string) => {
    updateRequest({ vendorContactInfo: value });
  };

  return (
    <TextField
      label="Vendor Contact Info"
      value={request?.vendorContactInfo || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      placeholder="Phone, email, or contact details"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <ContactPhoneOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FacilityMaintenanceVendorContactEditor;
